// extracted by mini-css-extract-plugin
export default {"textarea":"FormFieldWrapper_textarea__NpH9t","displayValue":"FormFieldWrapper_displayValue__QVPg4"};